export const ITEM_PER_PAGE = process.env.REACT_APP_COLLECTION_ITEM_PER_PAGE;

export const ITEM_PER_PAGE_CHOICES = ["5", "10", "25", "50", "100", "500"];
